import React from "react";
import { Navigate } from "react-router-dom";

/**
 * UserProtectedRoutes
 * - If user is logged in: redirect to their role-based main screen
 * - If not logged in: render the public component (Layout with home/login)
 */
const UserProtectedRoutes = ({ component: Component, ...rest }) => {
  let userDetails = null;
  try {
    userDetails = JSON.parse(localStorage.getItem("userDetails"));
  } catch {
    userDetails = null;
  }

  const token = userDetails?.token;
  const role = String(userDetails?.role || "").trim().toUpperCase();

  if (token) {
    if (role === "ADMIN" || role === "AE" || role === "ZM") {
      return <Navigate to="/masterData/dashboard" replace />;
    } else if (role === "AM" || role === "RM") {
      return <Navigate to="/amrm/farmerManagement" replace />;
    } else if (role === "SO" || role === "MDO") {
      return <Navigate to="/SOorMDO/dashboard" replace />;
    }
  }

  // Not logged in → show public layout (home, login, etc.)
  return <Component {...rest} />;
};

export default UserProtectedRoutes;
